/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextEditor } from 'react-data-grid';
import {
  Snackbar,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { selectCompanies, getAllCompanies, updateCompanies } from '../../store/companySlice';
import BaseDataGrid from '../common/BaseDataGrid';
import AddCompanyButton from '../common/AddCompanyButton';
import DropDownEditor from '../common/DropDownEditor';
import LookupFormatter from '../common/LookupFormatter';
import {
  clearMessage,
  selectMessage,
  selectSeverity,
} from '../../store/authSlice';
import DeleteCompanyModal from '../modals/DeleteCompanyModal';
import EditReservationTypesModal from '../modals/EditReservationTypesModal';
import EditPropertiesModal from '../modals/EditPropertiesModal';

export default function CompanyGrid() {
  const id = 'CompanyGrid';
  const dispatch = useDispatch();
  const message = useSelector(selectMessage);
  const severity = useSelector(selectSeverity);

  const handleClose = () => {
    dispatch(clearMessage());
  };

  const columns = [
    {
      key: 'id',
      name: 'ID',
      tooltip: 'Auto-incremental ID from the database.',
      width: 50,
    },
    {
      key: 'clientId',
      name: 'Client ID',
      tooltip: 'ID that identifies the company on an external system like Streamline.',
      width: 120,
      editor: TextEditor,
    },
    {
      key: '',
      name: 'Actions',
      width: 220,
      formatter: ({ row }) => (
        <>
          <DeleteCompanyModal companyId={row.id} />
          <EditReservationTypesModal companyId={row.id} clientId={row.clientId} />
          <EditPropertiesModal companyId={row.id} clientId={row.clientId} />
        </>
      ),
    },
    {
      key: 'companyType',
      name: 'Company Type',
      width: 200,
      editor: TextEditor,
    },
    {
      key: 'companyCode',
      name: 'Company Code',
      tooltip: "Token to be used to communicate with an external system's API.",
      width: 300,
      editor: TextEditor,
    },
    {
      key: 'companyName',
      name: 'Company Name',
      width: 300,
      editor: TextEditor,
    },
    {
      key: 'companyEmail',
      name: 'Company Email',
      width: 200,
      editor: TextEditor,
    },
    {
      key: 'companyPhone',
      name: 'Company Phone',
      width: 200,
      editor: TextEditor,
    },
    {
      key: 'companyLogo',
      name: 'Company Logo',
      width: 300,
      editor: TextEditor,
    },
    {
      key: 'autoAddressVerification',
      name: 'Auto Address Verification',
      width: 220,
      editor: (props) => (
        <DropDownEditor
          items={[
            { text: 'NO', value: 0 },
            { text: 'YES', value: 1 },
          ]}
          {...props}
        />
      ),
      formatter: (props) => (
        <LookupFormatter
          lookup={{
            0: 'NO',
            1: 'YES',
          }}
          {...props}
        />
      ),
    },
    {
      key: 'autoIdentityVerification',
      name: 'Auto Identity Verification',
      width: 220,
      editor: (props) => (
        <DropDownEditor
          items={[
            { text: 'NO', value: 0 },
            { text: 'YES', value: 1 },
          ]}
          {...props}
        />
      ),
      formatter: (props) => (
        <LookupFormatter
          lookup={{
            0: 'NO',
            1: 'YES',
          }}
          {...props}
        />
      ),
    },
  ];

  const toolbar = (
    <>
      <AddCompanyButton />
    </>
  );

  return (
    <>
      <BaseDataGrid
        id={id}
        columns={columns}
        selectData={selectCompanies}
        fetchData={getAllCompanies}
        updateData={updateCompanies}
        toolbar={toolbar}
      />
      <Snackbar open={!!message} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>{message}</Alert>
      </Snackbar>
    </>
  );
}
